<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :width="type === 1 || (type ===2 && coupons.length < 1)?'420px': '800px'"
    class="coupon-dialog">
    <div v-if="type === 1">
      <div class="subhead color-gray-6">Promo Code</div>
      <el-input v-model="couponCode" size="small" placeholder="Please Input"></el-input>
    </div>
    <div v-else>
      <div class="subhead color-gray-6">{{ coupons.length }} coupons available</div>
      <!-- 优惠券列表 -->
      <ul v-if="coupons && coupons.length" class="car-coupons-ul f-b-c">
        <CouponItem v-for="coupon in coupons" :key="coupon.key" :coupon="coupon" class="car-coupon-item" @click="onClickCoupon" />
      </ul>
    </div>
    <span v-if="type === 1" slot="footer">
      <el-button @click="dialogVisible = false">{{ $t('orderDetail.Cancel') }}</el-button>
      <el-button :loading="couponLoading" type="primary" @click="apply">{{ $t('orderDetail.Apply') }}</el-button>
    </span>
    <span v-else slot="footer" class="coupon-footer">
      <el-button :loading="couponLoading" type="primary" @click="Replace">{{ $t('orderDetail.Replace') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import API from '@/api'
import CouponItem from '@/components/CouponItem.vue'
import { guid } from '@/util/uuid'
export default {
  components: { CouponItem },
  props: {
    kkOrderId: {
      type: [String, Number],
      default: () => ''
    }
  },
  data() {
    return {
      type: 1, // 1优惠码 2优惠券
      title: '',
      dialogVisible: false,
      couponCode: '',
      couponLoading: false,
      orderInfo: {},
      orderBillingPreviewInfo: {},
      coupons: [],
      selCoupon: {}
    }
  },
  methods: {
    show(type, orderInfo, orderBillingPreviewInfo, coupons) {
      console.log(type, orderInfo, this.kkOrderId)
      this.type = type
      this.title = type === 1 ? 'Promo Code' : 'Coupon'
      this.orderInfo = orderInfo
      this.orderBillingPreviewInfo = orderBillingPreviewInfo
      // 只展示可用的
      this.coupons = _.cloneDeep(coupons).filter(t => t.ifUsed)
      this.dialogVisible = true
    },

    // 选择优惠券
    onClickCoupon(id) {
      let coupons = this.coupons
      coupons.forEach((item) => {
        if (item.id === id) {
          item.selected = !item.selected
          if (item.selected) {
            this.selCoupon = _.cloneDeep(item)
          } else {
            this.selCoupon = {}
          }
        } else {
          item.selected = false
        }
        item.key = `${guid(5)}_${item.id}`
      })
      this.coupons = coupons
    },

    apply() {
      if (!this.couponCode) return this.$message.warning(this.$t('promptText.msg16'))
      this.couponLoading = true
      const param = {
        couponCode: this.couponCode,
        hasOtherDiscount: !!this.orderInfo.pays.discountAmount,
        productNum: 0,
        transactionAmount: this.orderInfo.pays.skusAmount + this.orderInfo.pays.freightAmount,
        maxProductAmount: 0
      }
      this.orderInfo.orderItems.forEach(item => {
        param.productNum += +item.productNum
        if ((item.afterDiscountAmount ? item.afterDiscountAmount : item.purchasePrices) > param.maxProductAmount) {
          param.maxProductAmount = (item.afterDiscountAmount ? item.afterDiscountAmount : item.purchasePrices)
        }
      })
      API.couponCodeCheck(param).then(res => {
        if (res.code !== 10000) {
          return this.$message.error(res.message)
        }
        this.updateOrdersCoupon(res.data.discountAmount)
      }).finally(() => {
        this.couponLoading = false
      })
    },

    Replace() {
      if (!this.selCoupon.id) return this.$message.warning(this.$t('Order.List.Components.PayDialog.Tips2'))
      this.updateOrdersCoupon()
    },

    updateOrdersCoupon(couponAmount) {
      this.couponLoading = true
      let param = {}
      if (this.type === 1) {
        param.couponCode = this.couponCode
        param.couponAmount = couponAmount
      } else {
        param.couponTicketId = this.selCoupon.id
        param.fixedType = this.selCoupon.receiveUsageRules.offerTypeInfo.fixedType
        param.reduction = this.selCoupon.receiveUsageRules.offerTypeInfo.reduction
      }
      API.updateOrdersCoupon(param, this.kkOrderId).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success('successfully used')
        this.$emit('getOrderInfo')
        this.dialogVisible = false
        if (this.type === 1) this.couponCode = ''
      }).finally(() => {
        this.couponLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-dialog {
  .subhead {
    font-size: 13px;
    margin-bottom: 4px;
  }

  /deep/ .el-dialog__body {
    padding: 20px 28px !important;
  }

  /deep/ .el-input__inner {
    border-radius: 2px;
  }

  .car-coupons-ul {
    flex-wrap: wrap;

    .car-coupon-item {
      margin-bottom: 20px;
    }
  }
  .coupon-footer {
    /deep/ button {
      width: 100%;
      height: 40px;
    }
  }
}
</style>
